export enum FilteringType {
  WHITELIST = 'whitelist',
  BLACKLIST = 'blacklist',
}
